import { render, staticRenderFns } from "./TopicLabelDropdownItem.vue?vue&type=template&id=d642d2e0&scoped=true&"
import script from "./TopicLabelDropdownItem.vue?vue&type=script&lang=js&"
export * from "./TopicLabelDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./TopicLabelDropdownItem.vue?vue&type=style&index=0&id=d642d2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d642d2e0",
  null
  
)

export default component.exports